import styled, { css } from 'styled-components';
import { THEME } from '../../../themes';
import { Body1Font, ButtonFont, Title2Font } from '../../../themes/fonts';
import Dialog from '../base-dialog/base-dialog.component';
import BaseButton from '../../Common/Buttons/perfect-base-button/perfect-base-button.component';

const Container = css`
  display: flex;
  gap: ${THEME.SPACING.BASE};
  flex-direction: column;
  align-items: center;
  height: 100%;
`;

export const HeaderContainer = styled(Dialog.Header)`
  ${Container};
  padding: ${THEME.SPACING.MEDIUM} ${THEME.SPACING.MEDIUM} 0 ${THEME.SPACING.MEDIUM};
`;

export const FooterContainer = styled(Dialog.Footer)`
  ${Container};
  margin-top: ${THEME.SPACING.LARGE};
  margin-bottom: ${THEME.SPACING.BASE};
`;

export const DialogHeaderTitle = styled.div`
  ${ButtonFont};
  color: ${THEME.COLORS.CONTENT_A};
`;

export const EmojiContainer = styled.div`
  font-size: 49px;
`;

export const DialogBodyTitle = styled.div`
  ${Title2Font};
  font-weight: 600;
  max-width: 270px;
  text-align: center;
  color: ${THEME.COLORS.CONTENT_A};
`;

export const DialogBodySubTitle = styled.div`
  ${Body1Font};
  opacity: ${THEME.OPACITY.MED};
  color: ${THEME.COLORS.CONTENT_A};
  text-align: center;
  line-height: 1.5;
`;

export const ActionButton = styled(BaseButton)`
  background-color: ${THEME.COLORS.ACCENT};
  width: 160px;
  height: 48px;
`;
